// Author liang gang qiang
// Date 2021-09-28 15:21:04

import * as model from "@/model/mintalMes/mst/MintalMesMstEquipmentModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesMstEquipment(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_MST_URL,
    })
    .buildStore()
